import { CertificateListView } from "@/api/williams/certificates";
import { faFilePdf } from "@fortawesome/free-regular-svg-icons";
import { faUserPlus } from "@fortawesome/free-solid-svg-icons";
import { getFullPath, routes } from "../routes";
import { IconButton, useSelectedItems } from "../components";
import { printCertificate } from "@/api/williams/report";
import { useNavigate } from "react-router";
import { usePrintWelder } from "./hooks";
import { Welder, WelderListView } from "@/api/williams/welders";
import { WelderListViewType } from "./WelderList";

export type WelderListToolbarProps = {
  view: WelderListViewType;
};

export function WelderListToolbar({ view }: WelderListToolbarProps) {
  const print = usePrintWelder();
  const selected = useSelectedItems<WelderListView | CertificateListView>();
  const navigate = useNavigate();

  function handleDownloadPdf() {
    switch (view) {
      case "list": {
        const welders = selected.items as WelderListView[];
        print.showDialog(welders.map((x) => x.id));
        break;
      }
      case "certifications": {
        const certificates = selected.items as CertificateListView[];
        printCertificate(certificates.map((x) => x.recordId));
        break;
      }
    }
  }

  function handleAddRenewal() {
    switch (view) {
      case "list": {
        const welders = selected.items as WelderListView[];
        navigate(getFullPath(routes.welder.renewal), {
          state: { welders: welders.map((x) => ({ welderId: x.id, name: x.name })) as Welder[] },
        });
        break;
      }
    }
  }

  return (
    <div className="d-flex gap-2" style={{ height: 38 }}>
      <IconButton
        icon={faUserPlus}
        title="Add Renewal"
        disabled={selected.items.length === 0}
        hidden={view !== "list"}
        onClick={handleAddRenewal}
      />
      <IconButton
        icon={faFilePdf}
        title="Download PDF"
        disabled={selected.items.length === 0}
        hidden={view === "expirations"}
        onClick={handleDownloadPdf}
      />
    </div>
  );
}
